import isNumber from 'lodash-es/isNumber';
import { ReadOnly } from 'module/Common';

export type Size = ReadOnly<{
  width: number;
  height: number;
}>;

export namespace Size {
  export const create = (width: number, height: number): Size => {
    return { width, height };
  };

  export const createFromObject = (obj: { width: number; height: number }): Size => {
    return { width: obj.width, height: obj.height };
  };

  export const getRatio = (model: Size): number => {
    return model.width / model.height;
  };

  // Return a Size of ratio `ratio` that cover `size`
  export const coverRatio = (externalSize: Size, ratio: number): Size => {
    const externalRatio = getRatio(externalSize);
    if (ratio >= externalRatio) {
      // Same height, compute width
      return Size.create(externalSize.height * ratio, externalSize.height);
    }
    // Otherwize
    return Size.create(externalSize.width, externalSize.width / ratio);
  };

  export const fitInside = (size: Size, fitIn: Size): boolean => {
    const fit = size.width <= fitIn.width && size.height <= fitIn.height;
    return fit;
  };

  export const scale = (size: Size, amount: number): Size => {
    return Size.create(size.width * amount, size.height * amount);
  };
}

export type SizeForRatio = ReadOnly<
  | { width: number; height: number }
  | { width: 'auto' | number; height: number }
  | { width: number; height: 'auto' | number }
>;

export namespace SizeForRatio {
  export function create(width: number | 'auto', height: number): SizeForRatio;
  export function create(width: number, height: number | 'auto'): SizeForRatio;
  export function create(width: number, height: number): SizeForRatio {
    if ((width as any) === 'auto' && (height as any) === 'auto') {
      console.error('SizeForRatio need at least one number value !');
      return { width: 300, height: 300 };
    }
    return { width, height };
  }

  export function resolveForRatio(size: SizeForRatio, ratio: number): Size {
    if (isNumber(size.width) && isNumber(size.height)) {
      return Size.create(size.width, size.height);
    }
    if (isNumber(size.height)) {
      return Size.create(size.height * ratio, size.height);
    }
    if (isNumber(size.width)) {
      return Size.create(size.width, size.width / ratio);
    }
    console.error('SizeForRatio need at least one number value !');
    return Size.create(300, 300);
  }
}



// WEBPACK FOOTER //
// ./src/module/Model/Size/index.ts